import './style.scss';
import { useTransferDistination } from './hook';
import { PageLocationSP } from 'views/components/atoms/pageLocation';

export const TransferDistination = () => {
  const getNewVariables = () => {
    return {};
  };

  const { virtualAccounInfo, getVirtualAccountInfo } = useTransferDistination(getNewVariables(), false);
  return (
    <section className="outletWrapper">
      <PageLocationSP />
      <div className="transferDistinationWrapper">
        <div className="transferDistinationWrapper_description">
          弊社にご送金いただく口座は下記となります。なお振込先は、お客様ごとに異なる専用の口座番号をご用意しております。
        </div>
        <div className="transferDistinationWrapper_announce">
          <h1>金融機関名</h1>
          <h2>
            {virtualAccounInfo.data?.GetVirtualAccountInfo?.BankName}（
            {virtualAccounInfo.data?.GetVirtualAccountInfo?.BankCode}）
          </h2>
        </div>

        <div className="transferDistinationWrapper_announce">
          <h1>支店名</h1>
          <h2>
            {virtualAccounInfo.data?.GetVirtualAccountInfo?.BranchName}（
            {virtualAccounInfo.data?.GetVirtualAccountInfo?.BranchCode}）
          </h2>
        </div>

        <div className="transferDistinationWrapper_announce">
          <h1>口座種別</h1>
          <h2>{virtualAccounInfo.data?.GetVirtualAccountInfo?.AccountType}</h2>
        </div>

        <div className="transferDistinationWrapper_announce">
          <h1>口座名義人</h1>
          <h2>
            {virtualAccounInfo.data?.GetVirtualAccountInfo?.AccountHolder}（
            {virtualAccounInfo.data?.GetVirtualAccountInfo?.AccountHolderKana}）
          </h2>
        </div>

        <div className="transferDistinationWrapper_announce">
          <h1>口座番号</h1>
          <h2>{virtualAccounInfo.data?.GetVirtualAccountInfo?.AccountNumber}</h2>
        </div>
      </div>
    </section>
  );
};
